import { createFileRoute } from '@tanstack/react-router'

import { productQuery, stepsQuery } from '../../lib/queries'
import { ProductCard } from '../../screens/ProductCard'

export const Route = createFileRoute('/products/$id')({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(productQuery(params.id)),
      context.queryClient.ensureQueryData(stepsQuery()),
    ]),
  component: ProductCard,
})
